const primaryMain = '#041E42';
const primaryMainOpacity = 'rgba(4, 30, 66, 0.9)';
const secondaryMain = '#007AB8';
const secondaryMainOpacity = 'rgba(0, 122, 184, 0.5)';
const secondaryLight = '#8FB7E1';
const tertiaryMain = '#364B68';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
